export const default_avatar = 'https://9d13d6a2792908d08ec893dbd712a4c2.r2.cloudflarestorage.com/avatars/default_avatar.jpeg';
export const store_character = 'https://9d13d6a2792908d08ec893dbd712a4c2.r2.cloudflarestorage.com/avatars/storage_character.png';
export const sub_character_1 = 'https://9d13d6a2792908d08ec893dbd712a4c2.r2.cloudflarestorage.com/avatars/sub_character_1.png';
export const sub_character_2 = 'https://9d13d6a2792908d08ec893dbd712a4c2.r2.cloudflarestorage.com/avatars/sub_character_2.png';



